import {
  IonItem as IonicIonItem,
  IonAccordion as IonicIonAccordion,
} from '@ionic/react'
import styled from 'styled-components'
import { myPalette } from '~/shared/ui/theme/myPalette'

export const Price = styled.div`
  font-size: 22px;
  font-weight: 700;
`

export const DiscountPrice = styled(Price)`
  color: ${myPalette.blue.main};
`

export const OldPrice = styled.div`
  text-decoration: line-through;
  color: ${myPalette.mutedText.main};
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
`

export const PricesContainer = styled(IonicIonItem)`
  --background: transparent;
  --background-hover: transparent;
  --border-width: 0;
  --padding-start: 0;
  --inner-padding-end: 0;
  height: 28px;
  display: flex;
  font-size: 18px;
  font-weight: 700;
  flex-direction: row;

  &::part(native) {
    --padding-start: 0;
  }

  ion-icon {
    width: 18px;
  }
`
export const IonAccordion = styled(IonicIonAccordion)`
  background: transparent;
`

export const Content = styled.div`
  margin: 12px 0 0;
  display: flex;
  flex-direction: column;
  gap: 12px;
`

export const DiscountAmount = styled.div`
  color: ${myPalette.blue.main};
  line-height: 24px;
`

export const PriceRow = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  justify-content: space-between;
  align-items: center;
`

export const ContentRow = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: space-between;
`

export const DiscountTitle = styled.div`
  font-size: 16px;
`

export const DiscountAmountRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`
